<template>
  <div>
    <carousel
      ref="slider"
      :per-page="1"
      :loop="true"
      :autoplay="true"
      :autoplay-timeout="5000"
      :navigationEnabled="width > 900 ? true : false"
      :paginationEnabled="false"
      :navigationNextLabel="retornaIconNext()"
      :navigationPrevLabel="retornaIconPrev()"
      >
      <slide v-for="banner in dados" :key="banner.bar_id">
        <a :href="banner.bar_link" target="_blank" class="ui-area-image">
          <div class="ui-show-image-area" :style="'background-image: url(' + banner.bar_imagem + ')'">
          </div>
          <img :src="banner.bar_imagem" :alt="banner.bar_nome">
        </a>
      </slide>
    </carousel>
  </div>
</template>

<script>
import Api from '@API'
import { Carousel, Slide } from 'vue-carousel'
export default {
  components: {
    Carousel,
    Slide
  },
  data () {
    return {
      width: screen.width,
      dados: []
    }
  },
  methods: {
    async getBanners () {
      this.loading = true
      await Api.get('banners/lista')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                bar_id: item.bar_id,
                bar_ativo: item.bar_ativo,
                bar_link: item.bar_link,
                bar_nome: item.bar_nome,
                bar_imagem: item.bar_imagem,
                uuid_bar_id: item.uuid_bar_id
              })
            })
            this.dados = info
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os banners!',
            color: 'error'
          })
          console.log(err)
        })
    },
    retornaIconNext () {
      let icone = '<i class="material-icons dark-icon">arrow_forward_ios</i>'
      if (this.$vuetify.theme.dark) {
        icone = '<i class="material-icons white-icon">arrow_forward_ios</i>'
      }
      return icone
    },
    retornaIconPrev () {
      let icone = '<i class="material-icons dark-icon">arrow_back_ios</i>'
      if (this.$vuetify.theme.dark) {
        icone = '<i class="material-icons white-icon">arrow_back_ios</i>'
      }
      return icone
    },
    loadFunctions () {
      this.getBanners()
    },
    loadContent () {
      this.loadFunctions()
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .dark-icon {
  color: #000!important;
}
>>> .white-icon {
  color: white!important;
}
>>> .VueCarousel-navigation-prev {
  left: 60px;
  &:focus {
    outline: none;
    user-select: none;
  }
}
>>> .VueCarousel-navigation-next {
  right: 60px;
  &:focus {
    outline: none;
    user-select: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheSlider.vue